import { useAuthContext } from "@auth/context/Auth.context";
import { useConfigurationContext } from "@hooks/useContext";
import { useEffect } from "react";

const NPS_SCRIPT_ID = "nps-script";

export const useNps = () => {
  const { idToken } = useAuthContext();
  const config = useConfigurationContext();

  useEffect(() => {
    if (!idToken || !config?.SENTINEL_NPS_URL) return;
    if (document.getElementById(NPS_SCRIPT_ID)) return;

    localStorage.setItem("idToken", idToken);
    const script = document.createElement("script");
    script.id = NPS_SCRIPT_ID;
    script.src = config.SENTINEL_NPS_URL;
    script.setAttribute("auth", "idToken");
    script.setAttribute("storage", "local");
    script.setAttribute("productId", config.SENTINEL_NPS_PRODUCT_ID);
    script.setAttribute("productName", config.SENTINEL_NPS_PRODUCT_NAME);

    document.head.appendChild(script);
  }, [idToken, config]);
};
